import { render } from "./Login.vue?vue&type=template&id=fc127904"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=fc127904&lang=css"

import exportComponent from "/Users/luqingbin/Documents/project/job_project/answer_ui1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__